class VersionNode extends HTMLElement {
	constructor() {
		super();
	}

	connectedCallback() {
		const dom = this.attachShadow({mode: "open"});
		const span = document.createElement("span");
		dom.appendChild(span);

		const fetchVersion = async () => {
			const resp = await fetch("/health");
			const j = await resp.json();
			// Releases report a bare number (1.0.16); local builds report vDev.
			span.textContent = /^\d/.test(j.v) ? "v" + j.v : j.v;
		};

		fetchVersion();
	}
}

customElements.define("b6-version", VersionNode);
